import React, { useEffect, useRef } from 'react';

import { Grid, InputAdornment, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const postFix = process.env.REACT_APP_DOMAIN_POSTFIX;

const useStyles = makeStyles(() => ({
  span: {
    gridArea: '1 / 1',
    textAlign: 'left',
    visibility: 'hidden',
    whiteSpace: 'nowrap',
  },
  textField: {
    '& .MuiInputAdornment-root': {
      gridArea: '1 / 2',
    },
    '& > div': {
      display: 'inline-grid',
      gridTemplateColumns: 'fit-content(26%)',
      width: '100%',
    },
    '& input': {
      gridArea: '1 / 1',
      minWidth: '80px',
      width: 'auto',
    },
  },
}));

export default (props) => {
  const classes = useStyles();
  const spanRef = useRef(null);

  const { value } = props;

  useEffect(() => {
    if (spanRef.current.textContent !== value || value === '') {
      spanRef.current.textContent = value;
    }
  }, [value]);

  const handleInput = (event) => {
    spanRef.current.textContent = event.currentTarget.value;
  };

  return (
    <Grid container alignItems="center">
      <Grid item>
        <div>
          <TextField
            {...props}
            className={classes.textField}
            InputProps={{
              endAdornment: <InputAdornment>.{postFix}</InputAdornment>,
              maxLength: 32,
              startAdornment: <span aria-hidden className={classes.span} ref={spanRef} />,
            }}
            onInput={handleInput}
          />
        </div>
      </Grid>
    </Grid>
  );
};
